import { registerPartySyncConnector } from './party.connector.js';
import { registerProductSyncConnector } from './product.connector.js';
/**
 * Registers all data-sync connectors. Call once at bootstrap
 * (alongside registerDescriptors / registerManifests).
 */
export function registerSyncConnectors() {
    registerProductSyncConnector();
    registerPartySyncConnector();
}
//# sourceMappingURL=index.js.map